module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mb-16",
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "justify-center": ""
    }
  }, [_c('item-list', {
    attrs: {
      "allowAdd": "",
      "allowDelete": "",
      "endpoint": _vm.endpoint + 'webhooks',
      "editRoute": "webhookEdit",
      "headers": _vm.headers,
      "name": "Webhook",
      "permissions": "webhooks",
      "extendedFab": "",
      "extendedFabText": "New Webhook"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-481e5808","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Webhooks.vue
// module id = 438
// module chunks = 1